import React from "react";
import { MathJax, MathJaxContext } from "better-react-mathjax";
import "katex/dist/katex.min.css";

export const mathJaxConfig = {
    loader: { load: ["input/tex", "output/chtml"] },
    tex: {
        inlineMath: [["$", "$"], ["\\(", "\\)"]],
        displayMath: [["$$", "$$"]],
    },
};

const HAS_MATH = /\$|\\\(|\\\[/;

// Renders **bold** and $...$ / $$...$$ / \(...\) / \[...\] math inline.
// Wrap any screen that uses this in <MathJaxContext config={mathJaxConfig}> once.
export const MathText = ({ text, className }) => {
    if (!text || typeof text !== "string") return <span className={className}>{text}</span>;

    return (
        <span className={`${className || ""} break-words`}>
            {text.split(/(\*\*[\s\S]*?\*\*)/g).map((part, index) => {
                if (!part) return null;
                if (part.length >= 4 && part.startsWith("**") && part.endsWith("**")) {
                    return (
                        <span key={index} className="font-bold">
                            {part.slice(2, -2)}
                        </span>
                    );
                }
                if (HAS_MATH.test(part)) {
                    // Long/wide equations don't wrap — scroll them horizontally in
                    // place instead of letting them overflow past their container.
                    return (
                        <span key={index} className="inline-block max-w-full overflow-x-auto align-middle">
                            <MathJax inline dynamic>
                                {part}
                            </MathJax>
                        </span>
                    );
                }
                return <span key={index}>{part}</span>;
            })}
        </span>
    );
};

export { MathJaxContext };
